import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Space, Typography } from '@pitchero/react-ui';
import Profile from '../squad/profile';
import ProfilePlaceholder from '../squad/profile-placeholder';
import { Trans } from '../../../lib/i18n';
import PROFILES_PROP_TYPES from '../../../lib/prop-types/profile';

const RelatedProfiles = ({ isLoading, teamId, profiles, profileType, seasonId }) => {
  if (!isLoading && profiles.length === 0) {
    return null;
  }

  return (
    <Space vertical="xxlarge">
      <Space bottom="small">
        <Typography
          preset="tab--active"
          responsive={[{ maxWidth: 'tab', props: { preset: 'tag--large' } }]}
          color="primary"
          component="h3"
        >
          <Trans i18nKey="teams:navigation_squad">Squad</Trans>
        </Typography>
      </Space>
      <Space bottom="medium">
        <Typography preset="title" color="black" component="h4">
          <Trans i18nKey={`teams:profile_header_related_${profileType}`}>
            {`Other ${profileType === 'player' ? 'Players' : 'Coaches'}`}
          </Trans>
        </Typography>
      </Space>
      <Grid preset="profiles">
        {isLoading ? (
          <>
            <ProfilePlaceholder />
            <ProfilePlaceholder />
            <ProfilePlaceholder />
            <ProfilePlaceholder />
            <ProfilePlaceholder />
            <ProfilePlaceholder />
          </>
        ) : (
          profiles.map((profile) => (
            <Profile key={profile.id} seasonId={seasonId} teamId={teamId} {...profile} />
          ))
        )}
      </Grid>
    </Space>
  );
};

RelatedProfiles.defaultProps = {
  seasonId: null,
};

RelatedProfiles.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  seasonId: PropTypes.number,
  teamId: PropTypes.number.isRequired,
  profiles: PROFILES_PROP_TYPES.isRequired,
  profileType: PropTypes.oneOf(['player', 'coach']).isRequired,
};

export default RelatedProfiles;
